import React from 'react';

const MessageStatus = ({ status }) => {
  // For 'sending' status, show a loading spinner
  if (status === 'sending') {
    return <div className="w-3.5 h-3.5 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>;
  }
  // For 'read' status, show two checkmarks (bright WhatsApp-style blue/sky-300)
  if (status === 'read') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-sky-300 drop-shadow-sm" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13l4 4L16 8M9 13l4 4L22 8" />
      </svg>
    );
  }
  // For 'delivered' status, show two checkmarks (faded/subtle white)
  if (status === 'delivered') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-white/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13l4 4L16 8M9 13l4 4L22 8" />
      </svg>
    );
  }
  // For 'sent' status, show one checkmark
  if (status === 'sent') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-white/50" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    );
  }
  return null;
};

export default MessageStatus;